'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var core = require('@react-pdf-viewer/core');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var OpenFileIcon = function () { return (React__namespace.createElement(core.Icon, { size: 16 },
    React__namespace.createElement("path", { d: "M12.5 4.5L12.5 19.5" }),
    React__namespace.createElement("path", { d: "M18 10L12.5 4.5 7 10" }),
    React__namespace.createElement("path", { d: "M17.5.5h5a1,1,0,0,1,1,1v21a1,1,0,0,1-1,1h-5" }),
    React__namespace.createElement("path", { d: "M6.5.5h-5a1,1,0,0,0-1,1v21a1,1,0,0,0,1,1h5" }))); };

var TOOLTIP_OFFSET = { left: 0, top: 8 };
var OpenButton = function (_a) {
    var onClick = _a.onClick;
    var l10n = React__namespace.useContext(core.LocalizationContext);
    var label = l10n && l10n.open ? l10n.open.openFile : 'Open file';
    var inputRef = React__namespace.createRef();
    var openFileDialog = function () {
        var inputEle = inputRef.current;
        if (inputEle) {
            inputEle.click();
        }
    };
    return (React__namespace.createElement(core.Tooltip, { ariaControlsSuffix: "open", position: core.Position.BottomCenter, target: React__namespace.createElement("div", { className: "rpv-open__input-wrapper" },
            React__namespace.createElement("input", { ref: inputRef, className: "rpv-open__input", multiple: false, tabIndex: -1, title: "", type: "file", onChange: onClick }),
            React__namespace.createElement(core.MinimalButton, { ariaLabel: label, onClick: openFileDialog },
                React__namespace.createElement(OpenFileIcon, null))), content: function () { return label; }, offset: TOOLTIP_OFFSET }));
};

var Open = function (_a) {
    var store = _a.store, children = _a.children;
    var handleOpenFiles = function (e) {
        var files = e.target.files;
        if (!files || !files.length) {
            return;
        }
        var openFile = store.get('openFile');
        if (openFile) {
            openFile(files[0]);
        }
    };
    var defaultChildren = function (props) { return React__namespace.createElement(OpenButton, { onClick: props.onClick }); };
    var render = children || defaultChildren;
    return render({
        onClick: handleOpenFiles,
    });
};

var OpenMenuItem = function (_a) {
    var onClick = _a.onClick;
    var l10n = React__namespace.useContext(core.LocalizationContext);
    var label = l10n && l10n.open ? l10n.open.openFile : 'Open file';
    var inputRef = React__namespace.createRef();
    var openFileDialog = function () {
        var inputEle = inputRef.current;
        if (inputEle) {
            inputEle.click();
        }
    };
    return (React__namespace.createElement(core.MenuItem, { icon: React__namespace.createElement(OpenFileIcon, null), onClick: openFileDialog },
        React__namespace.createElement("div", { className: "rpv-open__input-wrapper" },
            React__namespace.createElement("input", { ref: inputRef, className: "rpv-open__input", multiple: false, tabIndex: -1, title: "", type: "file", onChange: onClick }),
            label)));
};

var openPlugin = function () {
    var store = React__namespace.useMemo(function () { return core.createStore({}); }, []);
    var OpenDecorator = function (props) { return React__namespace.createElement(Open, __assign({}, props, { store: store })); };
    var OpenButtonDecorator = function () { return React__namespace.createElement(OpenDecorator, null); };
    var OpenMenuItemDecorator = function () { return React__namespace.createElement(OpenDecorator, null, function (p) { return React__namespace.createElement(OpenMenuItem, { onClick: p.onClick }); }); };
    return {
        install: function (pluginFunctions) {
            store.update('openFile', pluginFunctions.openFile);
        },
        Open: OpenDecorator,
        OpenButton: OpenButtonDecorator,
        OpenMenuItem: OpenMenuItemDecorator,
    };
};

exports.OpenFileIcon = OpenFileIcon;
exports.openPlugin = openPlugin;
